<template>
  <div class="card">
    <div class="card-body">
      <h4
        class="card-title"
        :class="
          $i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : 'txt-left'
        "
      >
        {{ $t("app.months") }}
        <p></p>
      </h4>
      <div
        v-for="(month, idx) in row.months"
        :key="idx"
        class="col-12 pd-0"
        :class="$i18n.locale == 'ar' ? '' : 'txt-left'"
        style="padding: 0"
      >
        <input
          class=""
          type="checkbox"
          :value="month['status']"
          :checked="month['status']"
          v-on:input="onChange(idx)"
        />
        <label
          :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''"
        >
          &nbsp; {{ month["value"] }} &nbsp;
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardMonths",
  props: ["months"],
  data() {
    return {
      row: {
        months: this.$props.months,
        selected: {},
      },
    };
  },
  mounted() {
    //console.log(this.$props.months[0]['value'])
  },
  methods: {
    //
    onChange(id) {
      // get status
      if (this.row.months[id]["status"]) {
        this.row.months[id]["status"] = false;
      } else {
        this.row.months[id]["status"] = true;
      }

      for (let i = 0; i < this.row.months.length; i++) {
        this.row.selected[i] = {
          key: this.row.months[i]["key"],
          value: this.row.months[i]["value"],
          status: this.row.months[i]["status"],
        };
      }

      let data = {
        months: this.row.selected,
      };

      this.$emit("monthsChange", data);
    },
  },
};
</script>
